import { render, staticRenderFns } from "./requestPayment.vue?vue&type=template&id=b5db38a8&scoped=true&"
import script from "./requestPayment.vue?vue&type=script&lang=js&"
export * from "./requestPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db38a8",
  null
  
)

export default component.exports